
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9at9H", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $foQ4a = parcelRequire("foQ4a");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

/* RestrictedSpaceForGuest.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $kNIYN = parcelRequire("kNIYN");


var $lfoFx = parcelRequire("lfoFx");


var $lLRfG = parcelRequire("lLRfG");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");







var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $jmjWc = parcelRequire("jmjWc");


const $90f6c3580ed52b68$export$3925ee1231e5e137 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "tijYB",
    name: "GuestRequestToUpgradeDialog",
    loader: async ()=>(await (parcelRequire("kfsr3"))).GuestRequestToUpgradeLearnMoreModal
});



var $4ZawZ = parcelRequire("4ZawZ");

/* GuestLearnMoreLink.tsx generated by @compiled/babel-plugin v3.0.2 */ 











const $fdd4f998abed0180$var$LearnMoreLink = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYzOLYo _2nTuUYOLYo",
            __cmplp.className
        ])
    });
});
const $fdd4f998abed0180$var$i18n = (0, $kSwu1.defineMessages)({
    learnMore: {
        id: "external-collab-ui.learn-more",
        defaultMessage: "Learn more"
    }
});
const $fdd4f998abed0180$export$f810eb001c376485 = ({ children: children, onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fdd4f998abed0180$var$LearnMoreLink, {
        onClick: onClick,
        href: (0, $4ZawZ.LEARN_MORE_LINK),
        target: "_blank"
    }, children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $fdd4f998abed0180$var$i18n.learnMore));
};



var $gqqjz = parcelRequire("gqqjz");


var $auKqk = parcelRequire("auKqk");


var $f3euL = parcelRequire("f3euL");

var $19824710e420fbf1$exports = {};
$19824710e420fbf1$exports = new URL("RestrictedContentIcon-Dark.bc90ae31.svg", import.meta.url).toString();


var $70faa22212588b14$exports = {};
$70faa22212588b14$exports = new URL("RestrictedContentIcon-Light.e0fef1fb.svg", import.meta.url).toString();






var $9DHhW = parcelRequire("9DHhW");


var $eh0mb = parcelRequire("eh0mb");


var $lyF5K = parcelRequire("lyF5K");

const $89cd66f81870f5e8$export$f7109619a5e9e0d6 = 'noSpaceAccess';
const $89cd66f81870f5e8$var$UI_EVENT = 'sendUIEvent';
const $89cd66f81870f5e8$var$SCREEN_EVENT = 'sendScreenEvent';
const $89cd66f81870f5e8$var$TRACK_EVENT = 'sendTrackEvent';
const $89cd66f81870f5e8$var$CLICKED = 'clicked';
const $89cd66f81870f5e8$var$BUTTON = 'button';
const $89cd66f81870f5e8$export$1d910a789ef52c48 = ()=>{
    const [showDialog, setShowDialog] = (0, $cozmU.useState)(false);
    const [{ requestAccessState: requestAccessState }, { setRequestAccessState: setRequestAccessState }] = (0, $eh0mb.useGuestRequestUpgradeStore)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { upgradeStatus: upgradeStatus, upgradeStatusReason: upgradeStatusReason, loading: loading, error: error } = (0, $lyF5K.useGuestRequestToUpgradeStatus)();
    (0, $cozmU.useEffect)(()=>{
        setRequestAccessState(upgradeStatusReason === 'PENDING_REQUEST_EXISTS' ? 'submitted' : undefined);
    }, [
        upgradeStatusReason,
        setRequestAccessState
    ]);
    const toggleDialog = ()=>setShowDialog((prevState)=>!prevState);
    const fireLearnMoreClickedAnalytics = ()=>createAnalyticsEvent({
            type: $89cd66f81870f5e8$var$UI_EVENT,
            data: {
                action: $89cd66f81870f5e8$var$CLICKED,
                actionSubject: $89cd66f81870f5e8$var$BUTTON,
                actionSubjectId: 'learnMoreLink',
                source: $89cd66f81870f5e8$export$f7109619a5e9e0d6
            }
        }).fire();
    const fireRequestAccessClickedAnalytics = ()=>createAnalyticsEvent({
            type: $89cd66f81870f5e8$var$UI_EVENT,
            data: {
                action: $89cd66f81870f5e8$var$CLICKED,
                actionSubject: $89cd66f81870f5e8$var$BUTTON,
                actionSubjectId: 'requestAccess',
                source: $89cd66f81870f5e8$export$f7109619a5e9e0d6
            }
        }).fire();
    const fireViewScreenAnalytics = (0, $cozmU.useCallback)((canRequestUpgrade)=>createAnalyticsEvent({
            type: $89cd66f81870f5e8$var$SCREEN_EVENT,
            data: {
                actionSubjectId: canRequestUpgrade ? 'guestEligibleToUpgrade' : 'guestIneligibleToUpgrade',
                name: $89cd66f81870f5e8$export$f7109619a5e9e0d6
            }
        }).fire(), [
        createAnalyticsEvent
    ]);
    const fireOnRequestSubmittedAnalytics = (hasError)=>createAnalyticsEvent({
            type: $89cd66f81870f5e8$var$TRACK_EVENT,
            data: {
                action: hasError ? 'failed' : 'requested',
                actionSubject: 'productAccess',
                source: $89cd66f81870f5e8$export$f7109619a5e9e0d6
            }
        }).fire();
    return {
        fireOnRequestSubmittedAnalytics: fireOnRequestSubmittedAnalytics,
        fireRequestAccessClickedAnalytics: fireRequestAccessClickedAnalytics,
        fireLearnMoreClickedAnalytics: fireLearnMoreClickedAnalytics,
        fireViewScreenAnalytics: fireViewScreenAnalytics,
        showDialog: showDialog,
        toggleDialog: toggleDialog,
        isRequestAccessPending: !!requestAccessState,
        loading: loading,
        error: error,
        canRequestUpgrade: upgradeStatus == 'CAN_REQUEST'
    };
};


const $3746f33f02cf7268$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    errorMessageWithRequestAccess: {
        id: "no-permission.restricted.space.guest.requestAccessMessage",
        defaultMessage: "Guest users can only access content in one space. Request licensed user access to unlock content in more spaces."
    },
    errorMessageWithoutRequestAccess: {
        id: "no-permission.restricted.space.guest.message",
        defaultMessage: "You are a guest on this Confluence site, so you can only access content in one space. {learnMoreLink}"
    },
    flagSuccessTitle: {
        id: "no-permission.restricted.space.guest.request-access.flag-success-title",
        defaultMessage: "Licensed user request sent!"
    },
    flagSuccessDescription: {
        id: "no-permission.restricted.space.guest.request-access.flag-success-description",
        defaultMessage: "If approved, you\u2019ll get a confirmation message from admin"
    },
    flagErrorTitle: {
        id: "no-permission.restricted.space.guest.request-access.flag-error-title",
        defaultMessage: "Request not sent"
    },
    flagErrorDescription: {
        id: "no-permission.restricted.space.guest.request-access.flag-error-description",
        defaultMessage: "Refresh the page to resubmit your request, or try again later."
    },
    learnMore: {
        id: "no-permission.restricted.space.learnMore",
        defaultMessage: "Learn more about guest users"
    },
    learnMoreButton: {
        id: "no-permission.restricted.space.learnMoreButton",
        defaultMessage: "More about guest users"
    },
    requestAccessButton: {
        id: "no-permission.restricted.space.request.access.requestAccess",
        defaultMessage: "Request full access"
    },
    requestAccessPendingButton: {
        id: "no-permission.restricted.space.request.access.requestAccessPending",
        defaultMessage: "Request pending approval"
    },
    title: {
        id: "no-permission.restricted.space.guest.title",
        defaultMessage: "You don\u2019t have access to this content"
    }
});
const $3746f33f02cf7268$var$CUSTOM_ATTRIBUTES = {
    inaccessiblePageType: 'RESTRICTED_SPACE_FOR_GUEST'
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3746f33f02cf7268$var$SpinnerContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0hPCNLDIqT _0jFU0V3DHH",
            __cmplp.className
        ])
    });
});
const $3746f33f02cf7268$var$RestrictedSpaceForGuestComponent = ({ flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { fireOnRequestSubmittedAnalytics: fireOnRequestSubmittedAnalytics, fireLearnMoreClickedAnalytics: fireLearnMoreClickedAnalytics, fireRequestAccessClickedAnalytics: fireRequestAccessClickedAnalytics, fireViewScreenAnalytics: fireViewScreenAnalytics, canRequestUpgrade: canRequestUpgrade, showDialog: showDialog, toggleDialog: toggleDialog, isRequestAccessPending: isRequestAccessPending, loading: loading } = (0, $89cd66f81870f5e8$export$1d910a789ef52c48)();
    (0, $cozmU.useEffect)(()=>{
        if (!loading) fireViewScreenAnalytics(canRequestUpgrade);
    }, [
        loading,
        canRequestUpgrade,
        fireViewScreenAnalytics
    ]);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3746f33f02cf7268$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "large",
        interactionName: "restricted-space-for-guest"
    }));
    const handleError = (submissionError)=>{
        flags.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3746f33f02cf7268$export$a7357cdd1f0b0168.flagErrorTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3746f33f02cf7268$export$a7357cdd1f0b0168.flagErrorDescription)
        });
        experienceTracker.fail({
            name: (0, $irVI7.SUBMIT_GUEST_REQUEST_TO_UPGRADE_EXPERIENCE),
            error: submissionError
        });
    };
    const handleOnSubmit = (error)=>{
        fireOnRequestSubmittedAnalytics(!!error);
        if (!error) flags.showSuccessFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3746f33f02cf7268$export$a7357cdd1f0b0168.flagSuccessTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3746f33f02cf7268$export$a7357cdd1f0b0168.flagSuccessDescription)
        });
        else handleError(error);
    };
    const handlePrimaryButtonClick = ()=>{
        fireRequestAccessClickedAnalytics();
        toggleDialog();
    };
    const handleLearnMoreClick = ()=>{
        fireLearnMoreClickedAnalytics();
    };
    const errorMessage = canRequestUpgrade ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3746f33f02cf7268$export$a7357cdd1f0b0168.errorMessageWithRequestAccess) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$3746f33f02cf7268$export$a7357cdd1f0b0168.errorMessageWithoutRequestAccess,
        values: {
            learnMoreLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fdd4f998abed0180$export$f810eb001c376485), {
                onClick: handleLearnMoreClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3746f33f02cf7268$export$a7357cdd1f0b0168.learnMore))
        }
    });
    const requestToUpgradeErrorPageProps = canRequestUpgrade && {
        primaryButtonProps: {
            isDisabled: isRequestAccessPending,
            onClick: handlePrimaryButtonClick,
            children: formatMessage(isRequestAccessPending ? $3746f33f02cf7268$export$a7357cdd1f0b0168.requestAccessPendingButton : $3746f33f02cf7268$export$a7357cdd1f0b0168.requestAccessButton)
        },
        secondaryButtonProps: {
            children: formatMessage($3746f33f02cf7268$export$a7357cdd1f0b0168.learnMoreButton),
            href: (0, $4ZawZ.LEARN_MORE_LINK),
            target: '_blank',
            onClick: handleLearnMoreClick
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $auKqk.ErrorPageComponent), {
        errorImage: (0, (/*@__PURE__*/$parcel$interopDefault($70faa22212588b14$exports))),
        errorImageDark: (0, (/*@__PURE__*/$parcel$interopDefault($19824710e420fbf1$exports))),
        errorTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3746f33f02cf7268$export$a7357cdd1f0b0168.title),
        errorMessage: errorMessage,
        ...requestToUpgradeErrorPageProps
    }, showDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $90f6c3580ed52b68$export$3925ee1231e5e137), {
        analytics: {
            touchpointId: (0, $89cd66f81870f5e8$export$f7109619a5e9e0d6)
        },
        onSubmit: handleOnSubmit,
        requestPending: isRequestAccessPending,
        closeModal: toggleDialog
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.RESTRICTED_SPACE_FOR_GUEST_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lLRfG.PageLoadEnd), {
        metric: (0, $f3euL.INACCESSIBLE_PAGE_LOAD),
        customData: $3746f33f02cf7268$var$CUSTOM_ATTRIBUTES
    }));
};
const $3746f33f02cf7268$export$82a38cafea37f86b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).EXTERNAL_COLLAB
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.RESTRICTED_SPACE_FOR_GUEST_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3746f33f02cf7268$var$RestrictedSpaceForGuestComponent, {
            ...props,
            flags: flags
        })));



var $fxpoI = parcelRequire("fxpoI");


























var $cLo2u = parcelRequire("cLo2u");


var $bQm3c = parcelRequire("bQm3c");


var $8Lx5S = parcelRequire("8Lx5S");


var $euL71 = parcelRequire("euL71");








var $6mKj3 = parcelRequire("6mKj3");


var $kqv9Z = parcelRequire("kqv9Z");


var $lfsDZ = parcelRequire("lfsDZ");


var $3NZlV = parcelRequire("3NZlV");


var $27iZh = parcelRequire("27iZh");

var $a4ade973119ca74a$exports = {};
$a4ade973119ca74a$exports = new URL("ConfluenceLogo.37570e84.svg", import.meta.url).toString();











var $c9iq1 = parcelRequire("c9iq1");

/**
 * @generated SignedSource<<82a5b792866620ec2263e953d663eee5>>
 * @relayHash e40d50d63c2471f125fb17c4d9f52651
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2691e47af9434c4f51a5b8d62ef778ce4e472319f82fb503191ebe9512b75d3
const $a05f51b93b4a489c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_resolvedSpaceKeyForContent"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useRestrictedSpaceScreenButtonPropsResolvedSpaceKeyForContentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useRestrictedSpaceScreenButtonPropsResolvedSpaceKeyForContentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e40d50d63c2471f125fb17c4d9f52651",
            "id": "e2691e47af9434c4f51a5b8d62ef778ce4e472319f82fb503191ebe9512b75d3",
            "metadata": {},
            "name": "useRestrictedSpaceScreenButtonPropsResolvedSpaceKeyForContentQuery",
            "operationKind": "query",
            "text": "query useRestrictedSpaceScreenButtonPropsResolvedSpaceKeyForContentQuery($cloudId:ID!,$id:ID!){confluence_resolvedSpaceKeyForContent(cloudId:$cloudId,id:$id)}"
        }
    };
}();
$a05f51b93b4a489c$var$node.hash = "99120215e3cab15df2137f63795c234f";
var $a05f51b93b4a489c$export$2e2bcd8739ae039 = $a05f51b93b4a489c$var$node;












var $1NBp8 = parcelRequire("1NBp8");











var $9wGTI = parcelRequire("9wGTI");


var $83Z6R = parcelRequire("83Z6R");





var $7Sm4c = parcelRequire("7Sm4c");

const $4ee1735caf328529$var$RESOLVED_SPACE_KEY_FOR_CONTENT_QUERY = (0, $a05f51b93b4a489c$export$2e2bcd8739ae039);
const $4ee1735caf328529$export$a0ee72f2c720a5c3 = ({ confluenceJoinability: confluenceJoinability, identityLink: identityLink, updateSpaceAccessMutation: updateSpaceAccessMutation, spaceKey: spaceKey, contentId: contentId, isRequestAccessPending: isRequestAccessPending, spaceEnabled: spaceEnabled })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { edition: edition, isLoggedIn: isLoggedIn, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const lazyResolveSpaceKey = (0, $83Z6R.useLazyQueryPromiseInterop)($4ee1735caf328529$var$RESOLVED_SPACE_KEY_FOR_CONTENT_QUERY, {
        __callerPackage__: "no-permission"
    });
    const [hasSpaceKeyResolutionFailed, setHasResolutionFailed] = (0, $cozmU.useState)(false);
    // All buttons are defined here
    const requestLicenseButtonProps = (0, $cozmU.useMemo)(()=>({
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: "no-permission.request.license",
                defaultMessage: "Request full access"
            }),
            href: identityLink,
            target: '_blank',
            rel: 'noopener noreferrer',
            onClick: ()=>{
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestLicense',
                        source: 'restrictedSpaceScreen'
                    }
                }).fire();
            }
        }), [
        identityLink,
        createAnalyticsEvent
    ]);
    const goHomeButtonProps = (0, $cozmU.useMemo)(()=>({
            href: (0, $1NBp8.WIKI).toUrl(),
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: "no-permission.restricted.space.licensed-user.request-access.go-home-button",
                defaultMessage: "Go home"
            }),
            onClick: ()=>{
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        source: 'restrictedSpaceScreen',
                        actionSubject: 'button',
                        action: 'clicked',
                        actionSubjectId: 'goHome'
                    }
                }).fire();
            }
        }), [
        createAnalyticsEvent
    ]);
    const requestAccessButtonProps = (0, $cozmU.useMemo)(()=>{
        let buttonContent;
        if (isRequestAccessPending) buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "no-permission.restricted.space.licensed-user.request-access.request-access-pending-button",
            defaultMessage: "Access requested"
        });
        else if ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc_perms_ga_access_requests', 'isEnabled', true)) // `UNSAFE_expValEqualsNoExposure`, not `expValEquals`: this `useMemo` is evaluated on
        // every render of the restricted-space screen, including the joinability screens and the
        // requests-off screen that never show this button. `RestrictedSpaceScreen` fires the one
        // exposure, from the branch that actually renders the treatment.
        buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "no-permission.restricted.space.locked.request-access-button.non-final",
            defaultMessage: "Request access"
        });
        else if ((0, $9wGTI.fg)('access-request-dialog-content-fixes')) buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "no-permission.restricted.space.licensed-user.request-access.ask-for-access-button",
            defaultMessage: "Ask for access"
        });
        else buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "no-permission.restricted.space.licensed-user.request-access.request-access-button",
            defaultMessage: "Request space access"
        });
        return {
            isDisabled: isRequestAccessPending || hasSpaceKeyResolutionFailed,
            children: buttonContent,
            onClick: async ()=>{
                try {
                    if (hasSpaceKeyResolutionFailed) return;
                    let resolvedSpaceKey = spaceKey ?? '';
                    if (contentId && (0, $6mKj3.expVal)('confluence_frontend_ssr_space_not_found', 'isEnabled', false)) {
                        const result = await lazyResolveSpaceKey({
                            variables: {
                                cloudId: cloudId,
                                id: contentId
                            }
                        });
                        resolvedSpaceKey = result?.confluence_resolvedSpaceKeyForContent ?? '';
                    }
                    if (updateSpaceAccessMutation) await updateSpaceAccessMutation({
                        variables: {
                            spaceKey: resolvedSpaceKey
                        }
                    });
                    else {
                        if (!resolvedSpaceKey) throw new Error(`Failed to resolve space key`);
                        else throw new Error('Unexpected error');
                    }
                } catch (e) {
                    setHasResolutionFailed(true);
                    (0, $7Sm4c.markErrorAsHandled)(e);
                }
            }
        };
    }, [
        isRequestAccessPending,
        updateSpaceAccessMutation,
        lazyResolveSpaceKey,
        cloudId,
        contentId,
        hasSpaceKeyResolutionFailed,
        spaceKey
    ]);
    const getButtonProps = (0, $cozmU.useCallback)(()=>{
        if (confluenceJoinability === 'canJoinDirectly') return {
            primary: requestLicenseButtonProps,
            secondary: goHomeButtonProps
        };
        else if (confluenceJoinability === 'licensingInProgress') return {
            primary: goHomeButtonProps
        };
        else if (spaceEnabled === false) // Nothing to request when access requests are off. Strictly `=== false`: undefined means
        // loading or failed, and must keep offering the request-access button.
        return {
            primary: goHomeButtonProps
        };
        else if (!isLoggedIn || !isLicensed || edition === (0, $euL71.ConfluenceEdition).FREE) // Only one button for free edition or anonymous users or unlicensed users
        return {
            primary: goHomeButtonProps
        };
        else return {
            primary: requestAccessButtonProps,
            secondary: goHomeButtonProps
        };
    }, [
        requestLicenseButtonProps,
        goHomeButtonProps,
        requestAccessButtonProps,
        confluenceJoinability,
        spaceEnabled,
        edition,
        isLoggedIn,
        isLicensed
    ]);
    return getButtonProps();
};


/**
 * @generated SignedSource<<0f62f1a56a40beda12036f7b38d87079>>
 * @relayHash fafd88d9e5425adee837708f24fe26e5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6e5c90e051a98faf9b122bbc9ab32486b3ca5f72ce9308f9dcb08d833058b611
const $3f82aa9ae4283766$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "kind": "ObjectValue",
            "name": "confluenceRequestSpaceAccessInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "spaceKey"
    }, v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useRequestSpaceAccessMutationRequestSpaceAccessMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "ConfluenceRequestSpaceAccessPayload",
                            "kind": "LinkedField",
                            "name": "requestSpaceAccess",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useRequestSpaceAccessMutationRequestSpaceAccessMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "ConfluenceRequestSpaceAccessPayload",
                            "kind": "LinkedField",
                            "name": "requestSpaceAccess",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "fafd88d9e5425adee837708f24fe26e5",
            "id": "6e5c90e051a98faf9b122bbc9ab32486b3ca5f72ce9308f9dcb08d833058b611",
            "metadata": {},
            "name": "useRequestSpaceAccessMutationRequestSpaceAccessMutation",
            "operationKind": "mutation",
            "text": "mutation useRequestSpaceAccessMutationRequestSpaceAccessMutation($spaceKey:String!){confluence{requestSpaceAccess(confluenceRequestSpaceAccessInput:{spaceKey:$spaceKey}){spaceKey,success,errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}}"
        }
    };
}();
$3f82aa9ae4283766$var$node.hash = "b0656a69f5a88b248ff04228e7b73a8c";
var $3f82aa9ae4283766$export$2e2bcd8739ae039 = $3f82aa9ae4283766$var$node;















var $308Wd = parcelRequire("308Wd");

const $163f98496ced57cf$var$useRequestSpaceAccessMutationRequestSpaceAccessMutation = (0, $3f82aa9ae4283766$export$2e2bcd8739ae039);
const $163f98496ced57cf$export$24a5899b269a2e6 = (0, $kSwu1.defineMessages)({
    successFlagTitle: {
        id: "no-permission.restricted.space.licensed-user.request-access.success-flag.title",
        defaultMessage: "Request sent"
    },
    successFlagDescription: {
        id: "no-permission.restricted.space.licensed-user.request-access.success-flag.description",
        defaultMessage: "We\u2019ve asked the admin of the space to give you access."
    },
    generalErrorFlagTitle: {
        id: "no-permission.restricted.space.licensed-user.request-access.general-error-flag-title",
        defaultMessage: "Request not sent"
    },
    generalErrorFlagDescription: {
        id: "no-permission.restricted.space.licensed-user.request-access.general-error-flag-description",
        defaultMessage: "Refresh the page to resubmit your request, or try again later."
    },
    spaceCreatorUnavailableErrorFlagTitle: {
        id: "no-permission.restricted.space.licensed-user.request-access.space-creator-unavailable-error-flag-title",
        defaultMessage: "Can\u2019t request access"
    },
    spaceCreatorUnavailableErrorFlagDescription: {
        id: "no-permission.restricted.space.licensed-user.request-access.space-creator-unavailable-error-flag-description",
        defaultMessage: "This space\u2019s access request functionality isn\u2019t currently available. If you need access, reach out to an admin in your organization."
    }
});
const $163f98496ced57cf$export$597cdcb8e9361db = ({ flags: flags })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isRequestAccessPending, setIsRequestAccessPending] = (0, $cozmU.useState)();
    const getErrorMessage = (errorMessage, errorStatusCode)=>{
        if (errorStatusCode === 409) {
            window.location.reload();
            return null;
        } else if (errorStatusCode === 404 && errorMessage.includes('Space Creator is unavailable')) return {
            errorFlagTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $163f98496ced57cf$export$24a5899b269a2e6.spaceCreatorUnavailableErrorFlagTitle),
            errorFlagMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $163f98496ced57cf$export$24a5899b269a2e6.spaceCreatorUnavailableErrorFlagDescription),
            errorFlagType: 'spaceCreatorUnavailable'
        };
        return {
            errorFlagTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $163f98496ced57cf$export$24a5899b269a2e6.generalErrorFlagTitle),
            errorFlagMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $163f98496ced57cf$export$24a5899b269a2e6.generalErrorFlagDescription),
            errorFlagType: 'generalError'
        };
    };
    const [updateSpaceAccessMutation] = (0, $308Wd.useMutationInterop)($163f98496ced57cf$var$useRequestSpaceAccessMutationRequestSpaceAccessMutation, {
        onError: (data)=>{
            const errorStatusCode = data?.graphQLErrors[0]?.extensions?.statusCode;
            const errorMessage = data?.graphQLErrors[0]?.message;
            const errorFlagCopies = getErrorMessage(errorMessage, errorStatusCode);
            if (errorFlagCopies) {
                flags.showErrorFlag({
                    title: errorFlagCopies.errorFlagTitle,
                    description: errorFlagCopies.errorFlagMessage
                });
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        source: 'restrictedSpaceScreen',
                        actionSubject: 'flag',
                        action: 'shown',
                        actionSubjectId: 'errorFlag',
                        attributes: {
                            errorFlagTitle: errorFlagCopies.errorFlagType
                        }
                    }
                }).fire();
            }
            setIsRequestAccessPending(false);
        },
        onCompleted: ()=>{
            flags.showSuccessFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $163f98496ced57cf$export$24a5899b269a2e6.successFlagTitle),
                // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
                description: !(0, $9wGTI.fg)('access-request-dialog-content-fixes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $163f98496ced57cf$export$24a5899b269a2e6.successFlagDescription) : null
            });
            setIsRequestAccessPending(true);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: 'restrictedSpaceScreen',
                    actionSubject: 'button',
                    action: 'clicked',
                    actionSubjectId: 'requestSpaceAccess'
                }
            }).fire();
        },
        __callerPackage__: "no-permission"
    });
    return {
        updateSpaceAccessMutation: updateSpaceAccessMutation,
        isRequestAccessPending: isRequestAccessPending
    };
};


const $8b25ecb55def6d32$var$i18n = (0, $kSwu1.defineMessages)({
    accessDisabledTitle: {
        id: "no-permission.restricted.space.access-requests-disabled.title",
        defaultMessage: "This space is locked"
    },
    accessDisabledMessage: {
        id: "no-permission.restricted.space.access-requests-disabled.message",
        defaultMessage: "You don\u2019t have permission to access this space."
    },
    lockedSpaceTitle: {
        id: "no-permission.restricted.space.locked.title",
        defaultMessage: "This space is locked"
    },
    lockedSpaceMessage: {
        id: "no-permission.restricted.space.locked.message",
        defaultMessage: "You don\u2019t have permission to access this space. If you want access, send a request."
    }
});
const $8b25ecb55def6d32$var$PAGE_LOAD_CUSTOM_DATA = {
    inaccessiblePageType: 'RESTRICTED_SPACE'
};
const $8b25ecb55def6d32$var$FLAGS_CONTAINERS = [
    (0, $gqqjz.FlagsStateContainer)
];
const $8b25ecb55def6d32$export$358ea0c26d4a29d = ({ flags: flags, contentId: contentId, confluenceJoinability: confluenceJoinability, identityLink: identityLink })=>{
    const spaceKey = (0, $cLo2u.useSpaceKey)() || '';
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isLoggedIn: isLoggedIn, edition: edition } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    // Skipping the fetch gates the whole feature — the copy below and the buttons in useButtonProps
    // both branch on `spaceEnabled`, which stays undefined while skipped. Anonymous users are
    // skipped to match preloadAccessRequestSettings; useButtonProps offers them only "Go home"
    // regardless. UNSAFE_expValEqualsNoExposure so exposures come from the admin settings page
    // rather than every restricted-space view.
    const { spaceEnabled: spaceEnabled, spaceMessageContent: spaceMessageContent, loading: isAccessRequestSettingsLoading } = (0, $kqv9Z.useAccessRequestSettings)({
        skip: !isLoggedIn || !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc_perms_ga_access_requests', 'isEnabled', true)
    });
    const { isRequestAccessPending: isRequestAccessPending, updateSpaceAccessMutation: updateSpaceAccessMutation } = (0, $163f98496ced57cf$export$597cdcb8e9361db)({
        flags: flags
    });
    const { primary: primary, secondary: secondary } = (0, $4ee1735caf328529$export$a0ee72f2c720a5c3)({
        confluenceJoinability: confluenceJoinability,
        identityLink: identityLink,
        updateSpaceAccessMutation: updateSpaceAccessMutation,
        spaceKey: spaceKey,
        contentId: contentId,
        isRequestAccessPending: isRequestAccessPending,
        spaceEnabled: spaceEnabled
    });
    const getErrorMessages = (0, $cozmU.useCallback)(()=>{
        switch(confluenceJoinability){
            case 'canJoinDirectly':
                return {
                    errorTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                        id: "no-permission.restricted.space.title.authenticated.unlicensed",
                        defaultMessage: "You need full Confluence access to view this space"
                    }),
                    errorMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                        id: "no-permission.restricted.space.message.authenticated.unlicensed",
                        // oxlint-disable-next-line @atlassian/i18n/no-multiple-whitespaces
                        defaultMessage: "Your access to Confluence is currently limited. To view this space, you\u2019ll need submit a request for full access.    If this space is restricted, you may also need to submit request for space access."
                    }),
                    errorImage: (0, (/*@__PURE__*/$parcel$interopDefault($70faa22212588b14$exports))),
                    errorImageDark: (0, (/*@__PURE__*/$parcel$interopDefault($19824710e420fbf1$exports))),
                    layout: 'default'
                };
            case 'licensingInProgress':
                return {
                    errorTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                        id: "no-permission.restricted.space.title.authenticated.licensing.in.progress",
                        defaultMessage: "Your Confluence access is still processing"
                    }),
                    errorMessage: null,
                    errorImage: (0, (/*@__PURE__*/$parcel$interopDefault($a4ade973119ca74a$exports))),
                    errorImageDark: (0, (/*@__PURE__*/$parcel$interopDefault($a4ade973119ca74a$exports))),
                    layout: 'default'
                };
            default:
                // Strictly `=== false`, not `!spaceEnabled`: undefined means loading, skipped, or
                // failed, and those must keep the request-access screen.
                if (spaceEnabled === false) return {
                    errorTitle: formatMessage($8b25ecb55def6d32$var$i18n.accessDisabledTitle),
                    errorMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfsDZ.AccessDisabledMessage), {
                        messageContent: spaceMessageContent,
                        fallback: formatMessage($8b25ecb55def6d32$var$i18n.accessDisabledMessage)
                    }),
                    errorImage: (0, (/*@__PURE__*/$parcel$interopDefault($3NZlV))),
                    errorImageDark: (0, (/*@__PURE__*/$parcel$interopDefault($27iZh))),
                    layout: 'centered'
                };
                // The sole exposure site for `cc_perms_ga_access_requests`. The joinability cases and
                // the requests-off branch have already returned, so only a viewer who actually sees
                // the treatment is enrolled. Every other read of this experiment stays
                // `UNSAFE_expValEqualsNoExposure` on purpose: the settings `skip` above and
                // `preloadAccessRequestSettings` run on every space-key route (View Page included),
                // and the CTA label in `useButtonProps` is computed on every render regardless of
                // which screen wins.
                if ((0, $6mKj3.expValEquals)('cc_perms_ga_access_requests', 'isEnabled', true)) return {
                    errorTitle: formatMessage($8b25ecb55def6d32$var$i18n.lockedSpaceTitle),
                    errorMessage: isLoggedIn && isLicensed && edition !== (0, $euL71.ConfluenceEdition).FREE ? formatMessage($8b25ecb55def6d32$var$i18n.lockedSpaceMessage) : null,
                    errorImage: (0, (/*@__PURE__*/$parcel$interopDefault($3NZlV))),
                    errorImageDark: (0, (/*@__PURE__*/$parcel$interopDefault($27iZh))),
                    layout: 'centered'
                };
                return {
                    errorTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                        id: "no-permission.restricted.space.licensed-user.request-access.title",
                        defaultMessage: "You don\u2019t have access to this space"
                    }),
                    errorMessage: null,
                    errorImage: (0, (/*@__PURE__*/$parcel$interopDefault($70faa22212588b14$exports))),
                    errorImageDark: (0, (/*@__PURE__*/$parcel$interopDefault($19824710e420fbf1$exports))),
                    layout: 'default'
                };
        }
    }, [
        confluenceJoinability,
        spaceEnabled,
        spaceMessageContent,
        formatMessage,
        isLoggedIn,
        isLicensed,
        edition
    ]);
    // Hold the screen until the setting is known, as RestrictedSpace does for isDomainAccessLoading —
    // rendering early commits to the request-access screen and then visibly swaps. Preloading covers
    // SSR, but SPA transitions have none. The joinability screens don't read the setting, so they
    // must not be delayed. No gate check needed: a skipped query reports loading: false.
    const isJoinabilityScreen = confluenceJoinability === 'canJoinDirectly' || confluenceJoinability === 'licensingInProgress';
    if (isAccessRequestSettingsLoading && !isJoinabilityScreen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fxpoI.ShowSpinnerAfterDelay), null);
    const { errorTitle: errorTitle, errorMessage: errorMessage, errorImage: errorImage, errorImageDark: errorImageDark, layout: layout } = getErrorMessages();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $auKqk.ErrorPageComponent), {
        errorImage: errorImage,
        errorImageDark: errorImageDark,
        errorTitle: errorTitle,
        errorMessage: errorMessage,
        primaryButtonProps: primary,
        secondaryButtonProps: secondary,
        layout: layout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c9iq1.SuperAdminGateway), {
        type: "space",
        contentId: contentId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.RESTRICTED_SPACE_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lLRfG.PageLoadEnd), {
        metric: (0, $f3euL.INACCESSIBLE_PAGE_LOAD),
        customData: $8b25ecb55def6d32$var$PAGE_LOAD_CUSTOM_DATA
    }));
};
const $8b25ecb55def6d32$export$53ee40f7a1d4977 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: $8b25ecb55def6d32$var$FLAGS_CONTAINERS
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8b25ecb55def6d32$export$358ea0c26d4a29d, {
            flags: flags,
            ...props
        })));









var $jEeDd = parcelRequire("jEeDd");





var $f7B1p = parcelRequire("f7B1p");


var $5ZqQS = parcelRequire("5ZqQS");





var $d9tcB = parcelRequire("d9tcB");

// See here https://hello.atlassian.net/wiki/spaces/ETRUST/pages/640596761/API+Guide+-+v1+access-requests+request#Enum-Definitions
// for the enum definitions
var $21d3da76ec470ca3$var$AuthorizedCapabilities = /*#__PURE__*/ function(AuthorizedCapabilities) {
    AuthorizedCapabilities["DIRECT_ACCESS"] = "DIRECT_ACCESS";
    AuthorizedCapabilities["ACCESS_EXISTS"] = "ACCESS_EXISTS";
    AuthorizedCapabilities["ACCESS_GRANTED"] = "ACCESS_GRANTED";
    AuthorizedCapabilities["APPROVED_REQUEST_EXISTS"] = "APPROVED_REQUEST_EXISTS";
    return AuthorizedCapabilities;
}($21d3da76ec470ca3$var$AuthorizedCapabilities || {});
// These would be the bucket of enums that we are looking for which would convey that a user's newly
// granted license hasn't synced with Confluence yet
const $21d3da76ec470ca3$var$awaitingLicenseSyncBucket = [
    "ACCESS_EXISTS",
    "ACCESS_GRANTED",
    "APPROVED_REQUEST_EXISTS"
];
const $21d3da76ec470ca3$var$getJoinability = (capability, isAuthenticatedAndUnlicensed)=>{
    if (!isAuthenticatedAndUnlicensed || capability === null) return null;
    if (capability === "DIRECT_ACCESS") return 'canJoinDirectly';
    if ($21d3da76ec470ca3$var$awaitingLicenseSyncBucket.includes(capability)) return 'licensingInProgress';
    return null;
};
const $21d3da76ec470ca3$export$839386ba3b43ffb9 = ({ skipDomainCheck: skipDomainCheck = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cloudId: cloudId, userId: userId, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const [approvedCapabiity, setApprovedCapability] = (0, $cozmU.useState)(null);
    const [isDomainAccessLoading, setIsDomainAccessLoading] = (0, $cozmU.useState)(false);
    const [currentPageLink, setCurrentPageLink] = (0, $cozmU.useState)(null);
    const isAuthenticatedAndUnlicensed = accessStatus === (0, $d9tcB.AccessStatus).UNLICENSED_AUTHENTICATED_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    const checkDirectAccessCapability = (0, $cozmU.useCallback)(async ()=>{
        const params = new URLSearchParams({
            resource: `ari:cloud:confluence::site/${cloudId}`
        });
        try {
            const response = await (0, $f7B1p.cfetch)(`/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`, {
                method: 'GET',
                headers: {
                    resource: `ari:cloud:confluence::site/${cloudId}`,
                    ACCEPT: 'application/json',
                    'Account-Id': userId || ''
                }
            });
            const data = await response.json();
            const capability = Object.values(data.results)[0];
            if (Object.values($21d3da76ec470ca3$var$AuthorizedCapabilities).includes(capability)) {
                if (capability === "DIRECT_ACCESS") createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        source: 'restrictedSpaceScreen',
                        actionSubject: 'approvedAuthenticatedUnlicensedUser',
                        action: 'identified'
                    }
                }).fire();
                setApprovedCapability(capability);
            }
        } catch (e) {
            (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
        }
    }, [
        cloudId,
        userId,
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        const checkDomainJoinCapability = async ()=>{
            setIsDomainAccessLoading(true);
            await checkDirectAccessCapability();
            setIsDomainAccessLoading(false);
        };
        if (isAuthenticatedAndUnlicensed && !skipDomainCheck) checkDomainJoinCapability();
    }, [
        cloudId,
        userId,
        isAuthenticatedAndUnlicensed,
        checkDirectAccessCapability,
        skipDomainCheck
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Window is not defined if this component is rendered in SSR
        if (typeof window !== 'undefined') // Identity requires an absolute URL for redirection into Confluence
        // eslint-disable-next-line no-restricted-syntax
        setCurrentPageLink(encodeURIComponent(window.location.href));
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const identityLink = (0, $jEeDd.getLoginLink)((identity)=>`https://${identity}/join/user-access?resource=ari:cloud:confluence::site/${cloudId}&continue=${currentPageLink}`);
    return {
        confluenceJoinability: $21d3da76ec470ca3$var$getJoinability(approvedCapabiity, isAuthenticatedAndUnlicensed),
        identityLink: identityLink,
        isDomainAccessLoading: isDomainAccessLoading
    };
};


const $b8cff52bcf2ec9ae$export$5ef003f00c9525a1 = ({ contentId: contentId })=>{
    const { confluenceJoinability: confluenceJoinability, identityLink: identityLink, isDomainAccessLoading: isDomainAccessLoading } = (0, $21d3da76ec470ca3$export$839386ba3b43ffb9)({});
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    if (isDomainAccessLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fxpoI.ShowSpinnerAfterDelay), null);
    if (isExternalCollaborator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3746f33f02cf7268$export$82a38cafea37f86b), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.RESTRICTED_SPACE_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8b25ecb55def6d32$export$53ee40f7a1d4977), {
        contentId: contentId,
        confluenceJoinability: confluenceJoinability,
        identityLink: identityLink
    }));
};
module.exports["RestrictedSpace"] = $b8cff52bcf2ec9ae$export$5ef003f00c9525a1;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("d9tcB", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $adbc8f20ade62008$export$9d38595f26d62a61 = /*#__PURE__*/ function(AccessStatus) {
    AccessStatus["ANONYMOUS_ACCESS"] = "ANONYMOUS_ACCESS";
    AccessStatus["EXTERNAL_COLLABORATOR_ACCESS"] = "EXTERNAL_COLLABORATOR_ACCESS";
    AccessStatus["EXTERNAL_SHARE_ACCESS"] = "EXTERNAL_SHARE_ACCESS";
    AccessStatus["LICENSED_ADMIN_ACCESS"] = "LICENSED_ADMIN_ACCESS";
    AccessStatus["LICENSED_USE_ACCESS"] = "LICENSED_USE_ACCESS";
    AccessStatus["NOT_PERMITTED"] = "NOT_PERMITTED";
    AccessStatus["UNLICENSED_AUTHENTICATED_ACCESS"] = "UNLICENSED_AUTHENTICATED_ACCESS";
    return AccessStatus;
}({});
var $adbc8f20ade62008$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
var $adbc8f20ade62008$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["DEVELOPMENT"] = "DEVELOPMENT";
    Environment["PRODUCTION"] = "PRODUCTION";
    Environment["STAGING"] = "STAGING";
    return Environment;
}({});
module.exports["AccessStatus"] = $adbc8f20ade62008$export$9d38595f26d62a61;
module.exports["ConfluenceEdition"] = $adbc8f20ade62008$export$68577d543b14ae02;

});

parcelRegister("ln0hx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, timeout: timeout, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $cozmU.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            timeout: timeout,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("lLRfG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $gXfti = parcelRequire("gXfti");


var $78QFu = parcelRequire("78QFu");


var $7sK8i = parcelRequire("7sK8i");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $6VdZc = parcelRequire("6VdZc");


var $4XtQK = parcelRequire("4XtQK");


var $2O7Qv = parcelRequire("2O7Qv");

const $4291167636037428$var$PageLoadEndComponent = /*#__PURE__*/ (0, $cozmU.memo)(({ metric: metric, customData: customData = {}, stopTime: stopTime })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hasFiredRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredRef.current) return;
        hasFiredRef.current = true;
        if (metric) (0, $2O7Qv.addCustomTimingForMetric)(metric.key);
        (0, $gXfti.addUFOCustomData)({
            ...customData,
            ...typeof stopTime === 'number' ? {
                stopTime: stopTime
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
        (0, $7sK8i.resumeLowPriorityEvents)();
    // Not adding exhaustive dependencies because we want this to fire only once,
    // despite any changes to `customData`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        metric
    ]);
    (0, $4XtQK.reportHydrationError)(createAnalyticsEvent, metric?.key);
    return null;
});
const $4291167636037428$export$570dec5b65c6715b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($4291167636037428$var$PageLoadEndComponent);
module.exports["PageLoadEnd"] = $4291167636037428$export$570dec5b65c6715b;

});

parcelRegister("aJv6Q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("4XtQK", function(module, exports) {

var $5ZqQS = parcelRequire("5ZqQS");


var $dtDUi = parcelRequire("dtDUi");


var $6mKj3 = parcelRequire("6mKj3");

function $433efe87b2d05424$export$e885a680acb7d12e(createAnalyticsEvent, metricKey) {
    if (!(window?.__SSR_RENDERED__ && Boolean(window.__HYDRATION_FAILED__))) return;
    const { error: errorWithRoute, route: route } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
    const attribution = window.__SSR_REACT_STREAMING__ ? 'streaming-hydration' : 'hydration';
    if ((0, $6mKj3.expVal)('confluence_frontend_hydration_failure_reporting', 'isEnabled', false)) createAnalyticsEvent((0, $dtDUi.getHydrationFailureOperationalEvent)({
        source: `PageLoadEnd - ${metricKey}`,
        route: route,
        errorWithRoute: errorWithRoute,
        isSSRReactStreaming: Boolean(window.__SSR_REACT_STREAMING__)
    })).fire();
    else (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute, {
        attribution: attribution
    });
}
module.exports["reportHydrationError"] = $433efe87b2d05424$export$e885a680acb7d12e;

});

parcelRegister("dtDUi", function(module, exports) {
/* eslint-disable prefer-template */ 
var $64KID = parcelRequire("64KID");


var $fMEnQ = parcelRequire("fMEnQ");

const $dab54f7f733e6dc2$var$DOC_LINK = 'https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4848884799/Debugging+Hydration+Mismatches';
const $dab54f7f733e6dc2$export$476b9d1d68660527 = [
    {
        matchers: [
            /Hydration failed because the initial UI does not match what was rendered on the server/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /The server could not finish this Suspense boundary, likely due to an error during server rendering/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This root received an early update, before anything was able hydrate. Switched the entire root to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Text content does not match server-rendered HTML./
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating this Suspense boundary. Switched to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    //Production errors
    {
        matchers: [
            /Minified React error #418/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server in production. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #419/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #421/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #422/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #423/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #424/
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #425/
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    }
];
const $dab54f7f733e6dc2$export$5796b97ecb5a412 = (errorString)=>{
    for (const { matchers: matchers, friendlyError: friendlyError, hydrationFailed: hydrationFailed } of $dab54f7f733e6dc2$export$476b9d1d68660527){
        if (matchers.some((matcher)=>matcher.test(errorString))) return {
            ...friendlyError,
            originalString: errorString,
            hydrationFailed: hydrationFailed
        };
    }
    return {
        friendlyMessage: 'An additional error occurred, attached below.',
        docLink: '',
        fallback: true,
        originalString: errorString,
        hydrationFailed: false
    };
};
const $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2 = (url)=>{
    const match = (0, $fMEnQ.Route).matchFirst(Object.values((0, $64KID.namedRoutes)), url);
    return {
        error: new Error(`Hydration failed on route ${match?.name}`),
        route: match?.name || 'unknown'
    };
};
function $dab54f7f733e6dc2$export$260985b5e8a6fce6({ source: source, route: route, errorWithRoute: errorWithRoute, isSSRReactStreaming: isSSRReactStreaming }) {
    const attribution = isSSRReactStreaming ? 'streaming-hydration' : 'hydration';
    const error = $dab54f7f733e6dc2$var$trimTextLength(errorWithRoute.message || String(errorWithRoute), 1000);
    return {
        type: 'sendOperationalEvent',
        data: {
            source: source,
            route: route,
            action: 'failed',
            actionSubject: 'hydration',
            attributes: {
                error: error,
                route: route,
                attribution: attribution,
                isSSRReactStreaming: isSSRReactStreaming
            }
        }
    };
}
function $dab54f7f733e6dc2$var$trimTextLength(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
}
module.exports["matchHydrationError"] = $dab54f7f733e6dc2$export$5796b97ecb5a412;
module.exports["getHydrationErrorWithRoute"] = $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2;
module.exports["getHydrationFailureOperationalEvent"] = $dab54f7f733e6dc2$export$260985b5e8a6fce6;

});

parcelRegister("2O7Qv", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $a33Aa.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("1eaCJ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $03574d8c2683228e$export$4962f3898bd5c829(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { name: name, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== experienceTracker || $[2] !== name) {
        t1 = ()=>experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        t2 = [
            name,
            attributes,
            experienceTracker
        ];
        $[0] = attributes;
        $[1] = experienceTracker;
        $[2] = name;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceSuccess"] = $03574d8c2683228e$export$4962f3898bd5c829;

});

parcelRegister("kfsr3", function(module, exports) {

let $ebdb440b0a152fe7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ebdb440b0a152fe7$var$load("Wowvf"),
    $ebdb440b0a152fe7$var$load("hhss7"),
    $ebdb440b0a152fe7$var$load("1epse")
]).then(()=>parcelRequire('dUYlk'));

});

parcelRegister("4ZawZ", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ const $b68f978f1accac8b$export$997e23a0aec74966 = 'https://support.atlassian.com/confluence-cloud/docs/what-can-guests-see-and-do-on-confluence/';
module.exports["LEARN_MORE_LINK"] = $b68f978f1accac8b$export$997e23a0aec74966;

});

parcelRegister("auKqk", function(module, exports) {
/* ErrorPageComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $ad7Ou = parcelRequire("ad7Ou");


var $eKMV3 = parcelRequire("eKMV3");


var $buxP3 = parcelRequire("buxP3");


var $3izAL = parcelRequire("3izAL");


var $hhzGx = parcelRequire("hhzGx");


var $iNQQp = parcelRequire("iNQQp");

const $ae2504483138c997$var$ErrorContainerStyles = null;
const $ae2504483138c997$var$ErrorContainerMobileStyles = null;
const $ae2504483138c997$var$ErrorContainer = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, resizeContainerRef: resizeContainerRef, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: resizeContainerRef,
        "data-vc": "not-found-container",
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0hPCNLDIqT _0KLXrulfZc _0jFU0V3DHH _1EqgXlqUim",
            isMobile && "_0jFU0VWP8C",
            isCenteredLayout && "_2Y7lL4NHnM _4c065US40j _4kiQYA3DHH _0jFU0VIZbP _24h04i2Njc"
        ])
    }, children);
};
const $ae2504483138c997$var$ErrorPageWrapperStyles = null;
const $ae2504483138c997$var$ErrorPageWrapperMobileStyles = null;
const $ae2504483138c997$var$ErrorPageWrapper = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT _1EqgXlELL6 _0aFT5v1qpb",
            isMobile && "_0aFT5vbt8w",
            isCenteredLayout && "_2mHwu8NHnM _0aFT5vbt8w _0hPCNLDIqT _39xV02N91d _1EqgXlfqQP"
        ])
    }, children);
};
const $ae2504483138c997$var$AlignContentStyles = null;
const $ae2504483138c997$var$AlignContentMobileStyles = null;
const $ae2504483138c997$var$AlignContent = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2XghbEkG2W _4xdlr0DIqT _2fwxA5ecOK",
            isMobile && "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2fwxA5DIqT",
            isCenteredLayout && "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2fwxA5DIqT _39xV02N91d"
        ])
    }, children);
};
const $ae2504483138c997$var$ErrorTitleStyles = null;
const $ae2504483138c997$var$ErrorTitleMobileStyles = null;
const $ae2504483138c997$var$ErrorTitle = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("h1", {
        className: (0, $hekY6.default)([
            "_2XghbEdVAt _2sNsIgJ6H4 _1kk5Tku7m9 _39xV028WQH _1UtDYzy7kJ",
            isMobile && "_2sNsIgXwEm _39xV02Axt1",
            isCenteredLayout && "_2XghbEpjyN _2sNsIgJ6H4 _1kk5Tkmb2E _1UtDYzy7kJ _2fwxA5DIqT _39xV02N91d",
            isCenteredLayout && isMobile && "_2sNsIgJ6H4 _1kk5Tkmb2E _39xV02N91d"
        ])
    }, children);
};
const $ae2504483138c997$var$ErrorMessageStyles = null;
const $ae2504483138c997$var$ErrorMessageMobileStyles = null;
const $ae2504483138c997$var$ErrorMessage = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _313842ZqHV _0adFHsZqHV _1DCdHiZqHV _2XsHFMZqHV _1kk5Tku7m9 _1UtDYzy7kJ _1EqgXlcTmy",
            isMobile && "_2sNsIg20Hp _313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _1EqgXlAxt1",
            isCenteredLayout && "_2sNsIg20Hp _313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _1kk5Tku7m9 _3C14nsjBF4 _1UtDYzy7kJ _2fwxA5DIqT _1EqgXlfqQP",
            isMobile && isCenteredLayout && "_1EqgXlfqQP"
        ])
    }, children);
};
const $ae2504483138c997$var$ButtonContainerStyles = null;
const $ae2504483138c997$var$ButtonContainerMobileStyles = null;
const $ae2504483138c997$var$ButtonContainer = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuecOK",
            isMobile && "_37wbyuDIqT",
            isCenteredLayout && "_2mHwu85zaO _37wbyuDIqT _3TGfC9HnLE"
        ])
    }, children);
};
const $ae2504483138c997$var$primaryButtonStyles = (0, $buxP3.xcss)({
    cursor: 'pointer',
    marginTop: 'space.250'
});
const $ae2504483138c997$var$mobilePrimaryButtonStyles = (0, $buxP3.xcss)({
    cursor: 'pointer',
    marginTop: 'space.200'
});
const $ae2504483138c997$var$secondaryButtonStyles = (0, $buxP3.xcss)({
    cursor: 'pointer',
    marginTop: 'space.250',
    marginLeft: 'space.200'
});
const $ae2504483138c997$var$mobileSecondaryButtonStyles = (0, $buxP3.xcss)({
    cursor: 'pointer',
    marginTop: 'space.200',
    marginLeft: 'space.100'
});
const $ae2504483138c997$var$childrenStyles = (0, $buxP3.xcss)({
    // @ts-ignore TODO: refactor to remove need for hardcoded `-90px`
    marginTop: '-90px',
    marginInline: 'space.250',
    marginBottom: 'space.250',
    maxWidth: '700px'
});
const $ae2504483138c997$var$mobileChildrenStyles = (0, $buxP3.xcss)({
    // @ts-ignore TODO: refactor to remove need for hardcoded `-74px`
    marginTop: '-74px',
    marginInline: 'space.250',
    marginBottom: 'space.250',
    maxWidth: '700px'
});
const $ae2504483138c997$var$centeredErrorContainerStyles = null;
const $ae2504483138c997$var$centeredErrorPageWrapperStyles = null;
const $ae2504483138c997$var$centeredAlignContentStyles = null;
const $ae2504483138c997$var$centeredErrorTitleStyles = null;
const $ae2504483138c997$var$centeredErrorTitleMobileStyles = null;
const $ae2504483138c997$var$centeredErrorMessageStyles = null;
const $ae2504483138c997$var$centeredErrorMessageMobileStyles = null;
const $ae2504483138c997$var$centeredButtonContainerStyles = null;
const $ae2504483138c997$var$centeredButtonStyles = (0, $buxP3.xcss)({
    marginTop: 'space.300'
});
const $ae2504483138c997$var$centeredChildrenStyles = (0, $buxP3.xcss)({
    marginTop: 'space.500',
    marginInline: 'space.250',
    marginBottom: 'space.250',
    maxWidth: '640px',
    width: '100%'
});
const $ae2504483138c997$var$centeredChildrenMobileStyles = (0, $buxP3.xcss)({
    marginTop: 'space.400',
    marginInline: 'space.250',
    marginBottom: 'space.250',
    maxWidth: '640px',
    width: '100%'
});
const $ae2504483138c997$var$ErrorPageChildren = ({ isMobile: isMobile, isCenteredLayout: isCenteredLayout, children: children })=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children)) return null;
    if (isCenteredLayout) {
        if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ae2504483138c997$var$centeredChildrenMobileStyles
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ae2504483138c997$var$centeredChildrenStyles
        }, children);
    }
    if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $ae2504483138c997$var$mobileChildrenStyles
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $ae2504483138c997$var$childrenStyles
    }, children);
};
const $ae2504483138c997$export$8350f8038f1a598b = ({ errorImage: errorImage, errorImageDark: errorImageDark, errorTitle: errorTitle, errorMessage: errorMessage, primaryButtonProps: primaryButtonProps, secondaryButtonProps: secondaryButtonProps, primaryButtonWrapper: primaryButtonWrapper, secondaryButtonWrapper: secondaryButtonWrapper, children: children, layout: layout = 'default' })=>{
    const { resizeContainerRef: resizeContainerRef, shouldUseMobileLayout: shouldUseMobileLayout } = (0, $iNQQp.useErrorPageMobileLayout)();
    const isMobile = shouldUseMobileLayout; // CCCEMAU-2938: keep the centered layout added for Mohiti as an explicit opt-in so
    // legacy error pages continue using the existing shared layout until each consumer is
    // intentionally migrated.
    const isCenteredLayout = layout === 'centered';
    const renderPrimaryButton = ()=>{
        if (!primaryButtonProps?.children) return null;
        const button = 'href' in primaryButtonProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            appearance: "primary",
            ...primaryButtonProps
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            ...primaryButtonProps
        });
        const wrappedButton = primaryButtonWrapper ? primaryButtonWrapper(button) : button;
        if (isCenteredLayout && !isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ae2504483138c997$var$centeredButtonStyles
        }, wrappedButton);
        if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ae2504483138c997$var$mobilePrimaryButtonStyles
        }, wrappedButton);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ae2504483138c997$var$primaryButtonStyles
        }, wrappedButton);
    };
    const renderSecondaryButton = ()=>{
        if (!secondaryButtonProps?.children) return null;
        const button = 'href' in secondaryButtonProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            appearance: "default",
            ...secondaryButtonProps
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "default",
            ...secondaryButtonProps
        });
        const wrappedButton = secondaryButtonWrapper ? secondaryButtonWrapper(button) : button;
        if (isCenteredLayout && !isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ae2504483138c997$var$centeredButtonStyles
        }, wrappedButton);
        if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ae2504483138c997$var$mobileSecondaryButtonStyles
        }, wrappedButton);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $ae2504483138c997$var$secondaryButtonStyles
        }, wrappedButton);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2504483138c997$var$ErrorContainer, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout,
        resizeContainerRef: resizeContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2504483138c997$var$ErrorPageWrapper, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2504483138c997$var$AlignContent, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, errorImage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hhzGx.ErrorPageImage), {
        src: errorImage,
        srcDark: errorImageDark,
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2504483138c997$var$AlignContent, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2504483138c997$var$ErrorTitle, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, errorTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2504483138c997$var$ErrorMessage, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, errorMessage), (primaryButtonProps?.children || secondaryButtonProps?.children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2504483138c997$var$ButtonContainer, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, renderPrimaryButton(), renderSecondaryButton()))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2504483138c997$var$ErrorPageChildren, {
        isMobile: isMobile,
        isCenteredLayout: isCenteredLayout
    }, children));
};
module.exports["ErrorPageComponent"] = $ae2504483138c997$export$8350f8038f1a598b;

});

parcelRegister("hhzGx", function(module, exports) {
/* ErrorPageImage.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $cJ0FD = parcelRequire("cJ0FD");

const $c32ae4d4c06d56af$var$imageStylesMobile = null;
const $c32ae4d4c06d56af$var$imageStylesDesktop = null;
const $c32ae4d4c06d56af$var$centeredImageStyles = null;
const $c32ae4d4c06d56af$var$imageStyles = null;
function $c32ae4d4c06d56af$export$9afbc24a6b683cb2({ src: src, srcDark: srcDark, isMobile: isMobile, isCenteredLayout: isCenteredLayout }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        alt: "",
        src: src,
        srcDark: srcDark || src,
        className: (0, $hekY6.default)([
            isCenteredLayout && "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _3iDTPbvLZJ _39xV02NGHM _1EqgXlTTQh",
            !isCenteredLayout && isMobile && "_39xV02lIjS",
            !isCenteredLayout && !isMobile && "_39xV02ZqHV",
            !isCenteredLayout && "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _1EqgXlS2te"
        ])
    });
}
module.exports["ErrorPageImage"] = $c32ae4d4c06d56af$export$9afbc24a6b683cb2;

});

parcelRegister("iNQQp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8dwdz = parcelRequire("8dwdz");

const $5359ea5c70f1dd78$export$78b0da9378bc7a2d = ()=>{
    const MOBILE_BREAKPOINT = 700;
    const [isContainerNarrow, setIsContainerNarrow] = (0, $cozmU.useState)(false);
    const lastIsNarrowRef = (0, $cozmU.useRef)(null);
    const resizeObserverRef = (0, $cozmU.useRef)(null);
    const handleResize = ([entry])=>{
        const nextIsNarrow = entry.contentRect.width < MOBILE_BREAKPOINT;
        if (lastIsNarrowRef.current !== nextIsNarrow) {
            lastIsNarrowRef.current = nextIsNarrow;
            setIsContainerNarrow(nextIsNarrow);
        }
    };
    const resizeContainerRef = (element)=>{
        // Clean up previous observer
        if (resizeObserverRef.current) {
            resizeObserverRef.current.disconnect();
            resizeObserverRef.current = null;
        }
        // Set up new observer if element exists
        if (element) {
            const resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(element);
            resizeObserverRef.current = resizeObserver;
        }
    };
    // Combine existing mobile detection with container width detection
    const shouldUseMobileLayout = isContainerNarrow || (0, $8dwdz.shouldShowMobileWeb)();
    return {
        resizeContainerRef: resizeContainerRef,
        shouldUseMobileLayout: shouldUseMobileLayout
    };
};
module.exports["useErrorPageMobileLayout"] = $5359ea5c70f1dd78$export$78b0da9378bc7a2d;

});

parcelRegister("f3euL", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $1UCmC = parcelRequire("1UCmC");

const $af526147f97ee327$export$dcb53e05895a448a = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.INACCESSIBLE_PAGE_LOAD_KEY)
});
module.exports["INACCESSIBLE_PAGE_LOAD"] = $af526147f97ee327$export$dcb53e05895a448a;

});

parcelRegister("lSOAM", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");


var $8RwKN = parcelRequire("8RwKN");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).HOME.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $8RwKN.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const $2a47a9fc48674e91$export$c5aa7fcaede4a84d = (0, $iDdTC.metrics).pageLoad;
const $2a47a9fc48674e91$export$19ba7be4fcf34f3d = (0, $iDdTC.metrics).custom;
const $2a47a9fc48674e91$export$36d7a61d0660e29c = (0, $iDdTC.metrics).interaction;
const $2a47a9fc48674e91$var$concurrent = (0, $iDdTC.metrics).concurrent;
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createPageLoadMetric"] = $2a47a9fc48674e91$export$c5aa7fcaede4a84d;
module.exports["createCustomMetric"] = $2a47a9fc48674e91$export$19ba7be4fcf34f3d;
module.exports["createInteractionMetric"] = $2a47a9fc48674e91$export$36d7a61d0660e29c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("eh0mb", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $4708f874261747c2$var$Store = (0, $8s9DV.createStore)({
    initialState: {
        requestAccessState: undefined
    },
    actions: {
        setRequestAccessState: (value)=>({ setState: setState })=>{
                setState({
                    requestAccessState: value
                });
            }
    },
    name: 'guestRequestUpgradeStore'
});
const $4708f874261747c2$export$b72090e4288882db = (0, $kBr4q.createHook)($4708f874261747c2$var$Store);
module.exports["useGuestRequestUpgradeStore"] = $4708f874261747c2$export$b72090e4288882db;

});

parcelRegister("lyF5K", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $f7B1p = parcelRequire("f7B1p");


var $ebwTS = parcelRequire("ebwTS");

const $14503a2aea2a4136$export$1ee9ed72ffc111c1 = [
    // If a guest has "direct access", they will simply upgrade to a user immediately upon submitting a request without needing admin approval.
    (0, $ebwTS.CapabilityValues).DIRECT_ACCESS,
    // ... otherwise, they have the ability to request access, and wait for admin approval.
    (0, $ebwTS.CapabilityValues).REQUEST_ACCESS
];
const $14503a2aea2a4136$export$3ed095546414dc67 = [
    // The ones a Guest should never get, but technically exist on the endpoint:
    (0, $ebwTS.CapabilityValues).ACCESS_EXISTS,
    (0, $ebwTS.CapabilityValues).APPROVED_REQUEST_EXISTS,
    // The ones we expect to potentially get:
    (0, $ebwTS.CapabilityValues).DENIED_REQUEST_EXISTS,
    (0, $ebwTS.CapabilityValues).FORBIDDEN
];
const $14503a2aea2a4136$export$4e4260b083de0708 = 'product/member';
const $14503a2aea2a4136$export$d3e4104c62036f39 = (skip = false)=>{
    // if skip is true, we are not going to fetch the status, so we're not loading anything and it can be false
    // if skip is false, we are going to fetch the status and invoke API immediately, so loading can be true (same as previous implementation)
    const [loading, setLoading] = (0, $cozmU.useState)(!skip);
    const [error, setError] = (0, $cozmU.useState)();
    const [upgradeStatus, setUpgradeStatus] = (0, $cozmU.useState)(undefined);
    const [upgradeStatusReason, setUpgradeStatusReason] = (0, $cozmU.useState)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const fetchGuestUpgradeRequestStatus = (0, $cozmU.useCallback)(async ()=>{
        setLoading(true);
        const resource = `ari:cloud:confluence::site/${cloudId}`;
        const params = new URLSearchParams({
            resource: resource
        });
        return (0, $f7B1p.cfetch)(`/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        }).then((response)=>response.json()).then((data)=>{
            const statusArray = data.resultsV2[resource];
            const userCapabilityEntry = statusArray.find((entry)=>entry.role === $14503a2aea2a4136$export$4e4260b083de0708) || {};
            const status = userCapabilityEntry.accessMode;
            setUpgradeStatusReason(status);
            if ($14503a2aea2a4136$export$3ed095546414dc67.includes(status)) setUpgradeStatus((0, $ebwTS.UpgradeStatus).NOT_ELIGIBLE_TO_UPGRADE_AT_ALL);
            else if (status === (0, $ebwTS.CapabilityValues).PENDING_REQUEST_EXISTS) setUpgradeStatus((0, $ebwTS.UpgradeStatus).AN_UPGRADE_REQUEST_IS_PENDING);
            else if ($14503a2aea2a4136$export$1ee9ed72ffc111c1.includes(status)) setUpgradeStatus((0, $ebwTS.UpgradeStatus).CAN_REQUEST);
            else // We didn't get a valid value
            throw Error(`Did not receive a valid value for the accessMode status: ${status}.`);
        }).catch((caughtError)=>{
            // If anything fails, we just state you're not eligible, because we can't confirm it.
            setUpgradeStatus((0, $ebwTS.UpgradeStatus).NOT_ELIGIBLE_TO_UPGRADE_AT_ALL);
            setError(caughtError instanceof Error ? caughtError : new Error('Guest request to upgrade status load error', {
                cause: caughtError
            }));
        }).finally(()=>setLoading(false));
    }, [
        cloudId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        fetchGuestUpgradeRequestStatus();
    }, [
        fetchGuestUpgradeRequestStatus,
        skip
    ]);
    return {
        upgradeStatus: upgradeStatus,
        upgradeStatusReason: upgradeStatusReason,
        loading: loading,
        error: error
    };
};
module.exports["useGuestRequestToUpgradeStatus"] = $14503a2aea2a4136$export$d3e4104c62036f39;

});

parcelRegister("ebwTS", function(module, exports) {
const $2f24b685c1e47a17$export$408edfc5a854220e = {
    ACCESS_EXISTS: 'ACCESS_EXISTS',
    DIRECT_ACCESS: 'DIRECT_ACCESS',
    APPROVED_REQUEST_EXISTS: 'APPROVED_REQUEST_EXISTS',
    DENIED_REQUEST_EXISTS: 'DENIED_REQUEST_EXISTS',
    FORBIDDEN: 'FORBIDDEN',
    PENDING_REQUEST_EXISTS: 'PENDING_REQUEST_EXISTS',
    REQUEST_ACCESS: 'REQUEST_ACCESS'
};
var $2f24b685c1e47a17$export$309264bca7eef03f = /*#__PURE__*/ function(UpgradeStatus) {
    UpgradeStatus["CAN_REQUEST"] = "CAN_REQUEST";
    UpgradeStatus["AN_UPGRADE_REQUEST_IS_PENDING"] = "AN_UPGRADE_REQUEST_IS_PENDING";
    UpgradeStatus["NOT_ELIGIBLE_TO_UPGRADE_AT_ALL"] = "NOT_ELIGIBLE_TO_UPGRADE_AT_ALL";
    return UpgradeStatus;
}({});
module.exports["CapabilityValues"] = $2f24b685c1e47a17$export$408edfc5a854220e;
module.exports["UpgradeStatus"] = $2f24b685c1e47a17$export$309264bca7eef03f;

});

parcelRegister("fxpoI", function(module, exports) {
/* ShowSpinnerAfterDelay.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $lfoFx = parcelRequire("lfoFx");

const $0ee1b93a9384bc8e$export$46abe04786d4d5bb = 2000;
const $0ee1b93a9384bc8e$var$styles = {
    spinnerContainer: "_1mT5xdy1CL _2IhTon715P _3OE6xY715P _1VJPcaiDnZ"
};
const $0ee1b93a9384bc8e$var$i18n = (0, $kSwu1.defineMessages)({
    loadingContent: {
        id: "no-permission.loading-content",
        defaultMessage: "Loading content"
    }
});
const $0ee1b93a9384bc8e$export$bec92059adbffeba = ()=>{
    const [isTooSoonToShowSpinner, setIsTooSoonToShowSpinner] = (0, $cozmU.useState)(true);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        setTimeout(()=>{
            setIsTooSoonToShowSpinner(false);
        }, $0ee1b93a9384bc8e$export$46abe04786d4d5bb);
    }, []);
    return isTooSoonToShowSpinner ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0ee1b93a9384bc8e$var$styles.spinnerContainer,
        role: "progressbar",
        "aria-label": formatMessage($0ee1b93a9384bc8e$var$i18n.loadingContent)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "large",
        interactionName: "no-permission-loading"
    }));
};
module.exports["ShowSpinnerAfterDelay"] = $0ee1b93a9384bc8e$export$bec92059adbffeba;

});

parcelRegister("cLo2u", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $bDgLe.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("8Lx5S", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$9df55620e365effa = ()=>{
    const { isLoggedIn: isLoggedIn, hasConfluenceUser: hasConfluenceUser } = (0, $bQm3c.useSessionData)();
    return isLoggedIn && !hasConfluenceUser;
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};
module.exports["useIsLicensed"] = $30f02aa82d7102bc$export$ac4f65b11c57a33b;
module.exports["useIsAdmin"] = $30f02aa82d7102bc$export$99a5e4bc80d231ca;
module.exports["useIsGuest"] = $30f02aa82d7102bc$export$f9ffae90e66d63e;
module.exports["useIsAuthenticatedWithoutConfluenceUser"] = $30f02aa82d7102bc$export$9df55620e365effa;
module.exports["useAccessStatus"] = $30f02aa82d7102bc$export$41f8700aabec6a40;

});

parcelRegister("kqv9Z", function(module, exports) {

var $ctTo0 = parcelRequire("ctTo0");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");

const $99c6e251b2ec7d79$export$cba1c8c35ebe424d = (0, $ctTo0.default);
const $99c6e251b2ec7d79$export$4439c5c8012e5b3c = ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)($99c6e251b2ec7d79$export$cba1c8c35ebe424d, {
        variables: {
            cloudId: cloudId
        },
        skip: skip,
        __callerPackage__: "access-requests"
    });
    const settings = data?.confluence_accessRequestSettings;
    const spaceEnabled = settings?.spaceAccessRequestSettings?.enabled;
    const contentEnabled = settings?.contentAccessRequestSettings?.enabled;
    const spaceMessageContent = settings?.spaceAccessRequestSettings?.messageContent;
    const contentMessageContent = settings?.contentAccessRequestSettings?.messageContent;
    return {
        spaceEnabled: spaceEnabled,
        contentEnabled: contentEnabled,
        spaceMessageContent: spaceMessageContent,
        contentMessageContent: contentMessageContent,
        loading: loading,
        error: error,
        refetch: refetch
    };
};
module.exports["ACCESS_REQUEST_SETTINGS_QUERY"] = $99c6e251b2ec7d79$export$cba1c8c35ebe424d;
module.exports["useAccessRequestSettings"] = $99c6e251b2ec7d79$export$4439c5c8012e5b3c;

});

parcelRegister("ctTo0", function(module, exports) {
/**
 * @generated SignedSource<<991ce2d939a58c458f86c450ce401fbc>>
 * @relayHash cfd6fa9dcb9e9305611fc3619dc85ec3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5c673b0736dce3bbc3183b766ba5dc60fdc106f9b1261efc2d3ca8806009b3f6
const $d7558363fe39fca1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "enabled"
        },
        {
            "kind": "ScalarField",
            "name": "messageContent"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceAccessRequestSettingsConfiguration",
            "kind": "LinkedField",
            "name": "confluence_accessRequestSettings",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceAccessRequestSettings",
                    "kind": "LinkedField",
                    "name": "contentAccessRequestSettings",
                    "plural": false,
                    "selections": v1 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceAccessRequestSettings",
                    "kind": "LinkedField",
                    "name": "spaceAccessRequestSettings",
                    "plural": false,
                    "selections": v1 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAccessRequestSettingsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAccessRequestSettingsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "cfd6fa9dcb9e9305611fc3619dc85ec3",
            "id": "5c673b0736dce3bbc3183b766ba5dc60fdc106f9b1261efc2d3ca8806009b3f6",
            "metadata": {},
            "name": "useAccessRequestSettingsQuery",
            "operationKind": "query",
            "text": "query useAccessRequestSettingsQuery($cloudId:ID!){confluence_accessRequestSettings(cloudId:$cloudId){contentAccessRequestSettings{enabled,messageContent},spaceAccessRequestSettings{enabled,messageContent}}}"
        }
    };
}();
$d7558363fe39fca1$var$node.hash = "a036ba125a56fbf2de00fed43babc58f";
var $d7558363fe39fca1$export$2e2bcd8739ae039 = $d7558363fe39fca1$var$node;
module.exports["default"] = $d7558363fe39fca1$export$2e2bcd8739ae039;

});

parcelRegister("lfsDZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $jmjWc = parcelRequire("jmjWc");


var $a3jMl = parcelRequire("a3jMl");


var $8b5J5 = parcelRequire("8b5J5");


// AFTER_PAINT is the only valid priority: it must be <= AFTER_PAINT to render during SSR, and must
// not outrank its loadable ancestors RestrictedSpace and RestrictedPage, both AFTER_PAINT.
// See go/cc-loading-phases.
const $206a1189210ef273$var$AdfMessageRendererLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Lp_X_",
    name: "AdfMessageRendererLoader",
    loader: async ()=>(await (parcelRequire("9omqc"))).AdfMessageRenderer
});
const $206a1189210ef273$export$448c71c35ccdb928 = ({ messageContent: messageContent, fallback: fallback })=>{
    // Memoised so re-renders of the host screen don't re-parse the stored ADF, and so `adfDoc` keeps
    // a stable identity as a prop for the lazily-loaded renderer.
    const adfDoc = (0, $cozmU.useMemo)(()=>(0, $8b5J5.parseAdfString)(messageContent), [
        messageContent
    ]);
    if (!adfDoc || (0, $a3jMl.isAdfDocEmpty)(adfDoc)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, fallback);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE,
        renderOnError: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, fallback)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($206a1189210ef273$var$AdfMessageRendererLoader, {
        adfDoc: adfDoc
    }));
};
module.exports["AccessDisabledMessage"] = $206a1189210ef273$export$448c71c35ccdb928;

});

parcelRegister("a3jMl", function(module, exports) {
const $6d7f3eba4fcbd38f$export$28526d32114d204d = (doc)=>!doc?.content?.some((node)=>'content' in node && Array.isArray(node.content) && node.content.length > 0);
module.exports["isAdfDocEmpty"] = $6d7f3eba4fcbd38f$export$28526d32114d204d;

});

parcelRegister("8b5J5", function(module, exports) {
const $658e27c28236ff7a$export$e9523343c1a01d8b = (adfString)=>{
    if (!adfString) return undefined;
    try {
        return JSON.parse(adfString);
    } catch  {
        return undefined;
    }
};
module.exports["parseAdfString"] = $658e27c28236ff7a$export$e9523343c1a01d8b;

});

parcelRegister("9omqc", function(module, exports) {

let $6d67bf61bea69d8c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6d67bf61bea69d8c$var$load("cBeoH"),
    $6d67bf61bea69d8c$var$load("lN9TX"),
    $6d67bf61bea69d8c$var$load("6wr18"),
    $6d67bf61bea69d8c$var$load("iNbHV"),
    $6d67bf61bea69d8c$var$load("hhss7"),
    $6d67bf61bea69d8c$var$load("cGkFm"),
    $6d67bf61bea69d8c$var$load("3zE0U"),
    $6d67bf61bea69d8c$var$load("dWRHr"),
    $6d67bf61bea69d8c$var$load("ffEVr"),
    $6d67bf61bea69d8c$var$load("5gsbh"),
    $6d67bf61bea69d8c$var$load("hsRa9"),
    $6d67bf61bea69d8c$var$load("bEleE"),
    $6d67bf61bea69d8c$var$load("abBST"),
    $6d67bf61bea69d8c$var$load("aAWLw"),
    $6d67bf61bea69d8c$var$load("81dxo")
]).then(()=>parcelRequire('iXFpQ'));

});

parcelRegister("3NZlV", function(module, exports) {
module.exports = new URL("CantViewLightMohiti.f5dd9431.svg", import.meta.url).toString();

});

parcelRegister("27iZh", function(module, exports) {
module.exports = new URL("CantViewDarkMohiti.bd8dcb75.svg", import.meta.url).toString();

});

parcelRegister("c9iq1", function(module, exports) {
/* SuperAdminGateway.js generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $euL71 = parcelRequire("euL71");


var $jmjWc = parcelRequire("jmjWc");


const $696b00ea4a51f68f$export$428a8cf25dac230d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HvSfR",
    name: "AdminKeyUpSell",
    loader: async ()=>(await (parcelRequire("62gFr"))).AdminKeyUpSell
});






const $16cc13c688f30749$export$f265d8a86f21f5a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "lp1PT",
    name: "SuperAdminEntryPoint",
    loader: async ()=>(await (parcelRequire("geZDC"))).SuperAdminEntryPoint
});



var $0g3Y7 = parcelRequire("0g3Y7");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $aJv6Q = parcelRequire("aJv6Q");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8d849ce50e8d729c$var$SuperAdminEntry = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842QEt6",
            __cmplp.className
        ])
    });
});
$8d849ce50e8d729c$var$SuperAdminEntry.displayName = 'SuperAdminEntry';
const $8d849ce50e8d729c$var$SuperAdminGatewayComponent = ({ type: type, contentId: contentId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0g3Y7.AdminKeyEligibilityQuery), null, ({ loading: loading, edition: edition, canBeSuperAdmin: canBeSuperAdmin, error: error })=>{
        if (loading || error) return null;
        if (!canBeSuperAdmin) return null;
        return edition === (0, $euL71.ConfluenceEdition).PREMIUM ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d849ce50e8d729c$var$SuperAdminEntry, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $16cc13c688f30749$export$f265d8a86f21f5a8), {
            type: type,
            contentId: contentId
        })) : edition === (0, $euL71.ConfluenceEdition).FREE || edition === (0, $euL71.ConfluenceEdition).STANDARD ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8d849ce50e8d729c$var$SuperAdminEntry, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $696b00ea4a51f68f$export$428a8cf25dac230d), {
            type: type
        }))) : null;
    });
};
$8d849ce50e8d729c$var$SuperAdminGatewayComponent.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).oneOf([
        'page',
        'space'
    ]).isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string
};
const $8d849ce50e8d729c$export$55c6d178ea80c304 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
})($8d849ce50e8d729c$var$SuperAdminGatewayComponent);
module.exports["SuperAdminGateway"] = $8d849ce50e8d729c$export$55c6d178ea80c304;

});

parcelRegister("62gFr", function(module, exports) {

let $464fdbc808f541c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $464fdbc808f541c5$var$load("1GCFv"),
    $464fdbc808f541c5$var$load("6XCf4"),
    $464fdbc808f541c5$var$load("ebvEF"),
    $464fdbc808f541c5$var$load("aEiTV"),
    $464fdbc808f541c5$var$load("1qlDN"),
    $464fdbc808f541c5$var$load("1yVM6"),
    $464fdbc808f541c5$var$load("6f3t8")
]).then(()=>parcelRequire('ie54a'));

});

parcelRegister("geZDC", function(module, exports) {

let $bd2dc426d2b42bd3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bd2dc426d2b42bd3$var$load("1GCFv"),
    $bd2dc426d2b42bd3$var$load("aEiTV"),
    $bd2dc426d2b42bd3$var$load("euA5f")
]).then(()=>parcelRequire('bZz8I'));

});

parcelRegister("0g3Y7", function(module, exports) {

var $47wTh = parcelRequire("47wTh");


var $6b4nE = parcelRequire("6b4nE");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");

function $bb950e1e25a27f84$export$8e5be031fba9cbe5({ children: children }) {
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $47wTh.default), {
        __callerPackage__: "super-admin"
    });
    let errorToReportToChildren;
    let isUnauthorized = false;
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) {
            // If `edition` is not permitted to the current user (e.g. anonymous
            // access is not permitted), then the current user is definitely not
            // eligible for admin key. So here an unauthorized error is an expected
            // error.
            (0, $7Sm4c.markErrorAsHandled)(error);
            isUnauthorized = true;
        } else errorToReportToChildren = error;
    }
    return children({
        canBeSuperAdmin: isUnauthorized ? false : Boolean(data?.user?.confluence?.roles?.canBeSuperAdmin),
        edition: isUnauthorized ? undefined : data?.confluenceTenantContext?.editions?.confluence,
        error: errorToReportToChildren,
        loading: loading
    });
}
$bb950e1e25a27f84$export$8e5be031fba9cbe5.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired
};
module.exports["AdminKeyEligibilityQuery"] = $bb950e1e25a27f84$export$8e5be031fba9cbe5;

});

parcelRegister("47wTh", function(module, exports) {
/**
 * @generated SignedSource<<362a1c55530deb6358d27bb771916187>>
 * @relayHash ddcb713faea6264b16dad4287cf3b4b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9c461db223051b973a34720eaa2600107d2ff9fc02999a23f010aa25a82eb6ad
const $2c4160e57f9e3e3f$var$node = function() {
    var v0 = [
        {
            "concreteType": "Tenant",
            "kind": "LinkedField",
            "name": "tenant",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "cloudId"
                }
            ]
        },
        {
            "alias": "confluenceTenantContext",
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Editions",
                    "kind": "LinkedField",
                    "name": "editions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "confluence"
                        }
                    ]
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLConfluenceUserRoles",
                            "kind": "LinkedField",
                            "name": "roles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "canBeSuperAdmin"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "AdminKeyEligibilityQueryAdminKeyEligibilityQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "AdminKeyEligibilityQueryAdminKeyEligibilityQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "ddcb713faea6264b16dad4287cf3b4b4",
            "id": "9c461db223051b973a34720eaa2600107d2ff9fc02999a23f010aa25a82eb6ad",
            "metadata": {},
            "name": "AdminKeyEligibilityQueryAdminKeyEligibilityQuery",
            "operationKind": "query",
            "text": "query AdminKeyEligibilityQueryAdminKeyEligibilityQuery{tenant{cloudId},confluenceTenantContext:confluence_tenantContext{editions{confluence}},user:confluence_atlassianUser(current:true){id,confluence{roles{canBeSuperAdmin}}}}"
        }
    };
}();
$2c4160e57f9e3e3f$var$node.hash = "f9719ea98536123f3036cf46919010ba";
var $2c4160e57f9e3e3f$export$2e2bcd8739ae039 = $2c4160e57f9e3e3f$var$node;
module.exports["default"] = $2c4160e57f9e3e3f$export$2e2bcd8739ae039;

});

parcelRegister("83Z6R", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7EPz1 = parcelRequire("7EPz1");


var $6SsN4 = parcelRequire("6SsN4");


var $422HI = parcelRequire("422HI");


var $zXpxJ = parcelRequire("zXpxJ");


var $iffSy = parcelRequire("iffSy");


var $7q7rs = parcelRequire("7q7rs");


var $7M67g = parcelRequire("7M67g");


var $86okN = parcelRequire("86okN");


var $iF5wn = parcelRequire("iF5wn");

/**
 * Coerce an unknown thrown value into an ApolloErrorInterop, so a rejection carries Apollo's
 * `graphQLErrors` / `networkError` fields on both branches. Mirrors the helper in
 * `useLazyQueryInterop`.
 */ function $b847dc1d37d68706$var$toApolloError(err) {
    if ((0, $422HI.isApolloError)(err)) return err;
    const networkError = err instanceof Error ? err : new Error(String(err));
    return new (0, $422HI.ApolloErrorInterop)({
        networkError: networkError
    });
}
function $b847dc1d37d68706$export$dcf9d4e77de27956(query, options) {
    const operationName = (0, $7M67g.getRelayOperationName)(query);
    if ((0, $iffSy.isRelayEnabled)(options?.__callerPackage__, {
        operationName: operationName,
        phase: 'lazy'
    })) // eslint-disable-next-line react-hooks/rules-of-hooks -- Apollo/Relay route is branch-stable for a given caller package.
    return $b847dc1d37d68706$var$useLazyQueryPromiseInteropRelay(query, options);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- Apollo/Relay route is branch-stable for a given caller package.
    return $b847dc1d37d68706$var$useLazyQueryPromiseInteropApollo(query, options);
}
const $b847dc1d37d68706$var$useLazyQueryPromiseInteropApollo = (0, $3u0dr.isReactCompilerActiveV2)() ? function useLazyQueryPromiseInteropApollo(query, options) {
    const $ = (0, $bDgLe.c)(13);
    const resolversRef = (0, $cozmU.useRef)();
    let t0;
    if ($[0] !== query) {
        t0 = (0, $86okN.toDocumentNode)(query);
        $[0] = query;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== options) {
        t1 = options && {
            ...options,
            fetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.fetchPolicy),
            ...options.nextFetchPolicy ? {
                nextFetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.nextFetchPolicy)
            } : {}
        };
        $[2] = options;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = [
            t0,
            t1
        ];
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    const [doQuery, t3] = (0, $7EPz1.useLazyQuery)(...t2);
    const { data: data, error: error } = t3;
    let t4;
    let t5;
    if ($[7] !== data || $[8] !== error) {
        t4 = ()=>{
            if (data) resolversRef.current?.resolve?.(data);
            if (error) resolversRef.current?.reject?.(error);
        };
        t5 = [
            data,
            error
        ];
        $[7] = data;
        $[8] = error;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[11] !== doQuery) {
        t6 = (vars)=>{
            let resolve;
            let reject;
            const promise = new Promise((res, rej)=>{
                resolve = res;
                reject = rej;
            });
            resolversRef.current = {
                resolve: resolve,
                reject: reject
            };
            doQuery(vars);
            return promise;
        };
        $[11] = doQuery;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : function useLazyQueryPromiseInteropApollo(query, options) {
    const resolversRef = (0, $cozmU.useRef)();
    /**
   * NOTE: Using `onCompleted` and `onError` callbacks does not work as expected due to Apollo bug which is present in both v2 and v3 - https://github.com/apollographql/apollo-client/issues/9338
   */ // Interop-only fetch policies must be translated or they reach Apollo untranslated and silently
    // degrade to its default cache behaviour. That matters for `'no-store'` specifically: Apollo's
    // `'no-cache'` is its exact equivalent, and without this mapping a query that is correct today
    // would start writing to the cache.
    const [doQuery, { data: data, error: error }] = (0, $7EPz1.useLazyQuery)(...[
        (0, $86okN.toDocumentNode)(query),
        options && {
            ...options,
            fetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.fetchPolicy),
            ...options.nextFetchPolicy ? {
                nextFetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.nextFetchPolicy)
            } : {}
        }
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (data) resolversRef.current?.resolve?.(data);
        if (error) resolversRef.current?.reject?.(error);
    }, [
        data,
        error
    ]);
    return (0, $cozmU.useCallback)((vars)=>{
        let resolve;
        let reject;
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        // @ts-expect-error `resolve` and `reject` *will* be assigned via the Promise constructor, but TS can't guarantee that. This should be replaced with `Promise.withResolvers` once out jest setup properly supports that
        resolversRef.current = {
            resolve: resolve,
            reject: reject
        };
        doQuery(vars);
        return promise;
    }, [
        doQuery
    ]);
};
function $b847dc1d37d68706$var$useLazyQueryPromiseInteropRelay(query, options) {
    // Validate before any hook call so the throw isn't masked by useRelayEnvironment().
    if (!('params' in query)) throw new Error(`[Relay migration] unsupported tagged node provided for operation "${(0, $7M67g.getRelayOperationName)(query) ?? 'unknown'}". Please make sure you generated Relay artifacts for your operation`);
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const operationName = (0, $7M67g.getRelayOperationName)(query) ?? undefined;
    const hookVariables = (0, $iF5wn.useMemoObj)(options?.variables, options?.__callerPackage__, {
        operationName: operationName,
        phase: 'memo'
    });
    // Read through refs rather than closing over these directly, so the returned callback keeps a
    // `[environment, query]` dependency list. Every current caller drives it from a `useEffect`
    // dependency array, so a new identity per render would re-fire the query on each render.
    // `context` in particular is usually an inline object and would change identity every time.
    const latestOptionsRef = (0, $cozmU.useRef)(options);
    latestOptionsRef.current = options;
    const hookVariablesRef = (0, $cozmU.useRef)(hookVariables);
    hookVariablesRef.current = hookVariables;
    return (0, $cozmU.useCallback)((callOptions)=>{
        const hookOptions = latestOptionsRef.current;
        // Per-call options win over hook-level ones, and variables merge rather than replace —
        // matching Apollo, which merges the variables handed to its lazy `doQuery` over the ones
        // given to the hook.
        const variables = {
            ...hookVariablesRef.current,
            ...callOptions?.variables
        };
        // Shared with `queryInterop` so the fetch-policy mapping and the `noStore` derivation have
        // one home. `noStore` is load-bearing for this hook specifically: `PagePanelContentQuery`
        // runs through it and is one of the operations whose response carries two `Content` objects
        // sharing an id, so a missed flag reintroduces the record collision.
        return (0, $zXpxJ.executeRelayQuery)({
            environment: environment,
            query: query,
            variables: variables,
            fetchPolicy: callOptions?.fetchPolicy ?? hookOptions?.fetchPolicy,
            errorPolicy: callOptions?.errorPolicy ?? hookOptions?.errorPolicy ?? 'none',
            context: callOptions?.context ?? hookOptions?.context
        }).then((result)=>{
            // Diverges from `queryInterop`, which hands `{ data, error }` back: this hook mirrors
            // Apollo's promise, which rejects. Under `errorPolicy: 'all'` a result carries both
            // data and error, and Apollo's effect resolves before it rejects — a promise settles
            // once — so data being present means resolve.
            if (result.error && result.data === undefined) throw result.error;
            return result.data;
        }).catch((err)=>{
            // Reject with an ApolloErrorInterop on both branches, so callers can read
            // `graphQLErrors` / `networkError` without knowing which branch ran.
            throw $b847dc1d37d68706$var$toApolloError(err);
        });
    }, [
        environment,
        query
    ]);
}
module.exports["useLazyQueryPromiseInterop"] = $b847dc1d37d68706$export$dcf9d4e77de27956;

});

parcelRegister("jEeDd", function(module, exports) {

var $6LNuT = parcelRequire("6LNuT");


var $jH9cM = parcelRequire("jH9cM");


var $i3S9F = parcelRequire("i3S9F");


var $9wGTI = parcelRequire("9wGTI");


var $6X8o4 = parcelRequire("6X8o4");


var $ge2sX = parcelRequire("ge2sX");

function $2dd269c5e0cf48e9$export$264b5fa7ee2d3260(continueUrl) {
    const identity = $2dd269c5e0cf48e9$var$getIdentity();
    if (typeof continueUrl === 'function') continueUrl = continueUrl(identity);
    if (!continueUrl) continueUrl = window.location.href; // eslint-disable-line no-restricted-syntax
    return `https://${identity}/login?application=confluence&continue=${encodeURIComponent(continueUrl)}`;
}
function $2dd269c5e0cf48e9$var$getIdentity() {
    let identity;
    const DEFAULT_PRODUCTION = 'id.atlassian.com';
    const DEFAULT_STAGING = 'id.stg.internal.atlassian.com';
    // 2. Fall back to the frontend build environment:
    if (!identity) identity = "id.atlassian.com";
    if (!identity && (0, $jH9cM.isFedRamp)()) {
        const isStagingFed = false;
        identity = isStagingFed ? 'id.stg.atlassian-us-gov-mod.com' : 'id.atlassian-us-gov-mod.com';
    }
    // 3. Fall back to the backend runtime environment:
    if (!identity) {
        // Turning getLoginLink into a hook would add the complexity of skipability.
        // Given that (a) we're implementing a fallback here and (b) the frontend
        // app figures out whether login is necessary by looking at session data,
        // the backend runtime environment will very likely be known already.
        const environment = (0, $6X8o4.getValue)((0, $ge2sX.getSessionData)())?.environment;
        identity = environment === 'PRODUCTION' ? DEFAULT_PRODUCTION : DEFAULT_STAGING;
    }
    // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
    if (!(0, $i3S9F.isIsolatedCloud)() || !(0, $9wGTI.fg)('confluence_ic_custom_domain_links')) return identity;
    // IC domains are derived from runtime perimeter context; the environment
    // argument only affects non-IC resolution.
    return (0, $6LNuT.getDomainInContext)('id', 'prod') ?? identity;
}
module.exports["getLoginLink"] = $2dd269c5e0cf48e9$export$264b5fa7ee2d3260;

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

const $abc73c6f5c74c436$export$6d558eab13290f59 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
module.exports["useRouterLink"] = $abc73c6f5c74c436$export$6d558eab13290f59;

});

parcelRegister("ac2J9", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1,
            children: children
        });
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("8Z78B", function(module, exports) {
/**
 * @generated SignedSource<<abe1bfe242e74d4385961078bad185f8>>
 * @relayHash 56e1784a86c45537dbf4ab9c8bb1ffba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7
const $38160060fa19c5ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "key"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "56e1784a86c45537dbf4ab9c8bb1ffba",
            "id": "3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7",
            "metadata": {},
            "name": "onboardingStateGetOnboardingStateQuery",
            "operationKind": "query",
            "text": "query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key,value}}"
        }
    };
}();
$38160060fa19c5ea$var$node.hash = "201bff99b2bdca3d23c658876502ced3";
var $38160060fa19c5ea$export$2e2bcd8739ae039 = $38160060fa19c5ea$var$node;
module.exports["default"] = $38160060fa19c5ea$export$2e2bcd8739ae039;

});

parcelRegister("ivb8S", function(module, exports) {

var $209pV = parcelRequire("209pV");


var $e6fvz = parcelRequire("e6fvz");


var $cozmU = parcelRequire("cozmU");


var $7Sm4c = parcelRequire("7Sm4c");


var $8Lx5S = parcelRequire("8Lx5S");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");


var $cbOce = parcelRequire("cbOce");


var $8Z78B = parcelRequire("8Z78B");

const $6fc4b7bb962289cc$export$75d6c00965e77c = (0, $e6fvz.default);
const $6fc4b7bb962289cc$export$7ca8667598519375 = (data)=>{
    const state = {};
    // new graphQL call returns onboardingState array
    const { onboardingState: onboardingState } = data || {};
    // parse data and populate state accordingly
    if (onboardingState !== undefined && onboardingState !== null) for (const { key: key, value: value } of onboardingState){
        // key comes back as "{prefix}:{property}" format
        // split by ':' to get parsed {property}
        // some keys don't have a prefix, which is why we have the ||
        const parsedKey = key.split(':')[1] || key;
        if (!value) continue;
        if (/(true|false)/g.test(value)) state[parsedKey] = value === 'true';
        else state[parsedKey] = value;
    }
    return state;
};
const $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf = ()=>{
    const [setState, { error: error, called: called }] = (0, $308Wd.useMutationInterop)((0, $209pV.default), {
        update (_cache, { data: data }) {
            const states = data.setOnboardingState;
            (states ?? []).forEach(({ key: key, value: value })=>{
                // writeFragment can only handle a single data item at a time
                (0, $ij4CE.writeFragmentInterop)({
                    fragmentId: `OnboardingState:${key}`,
                    data: {
                        key: key,
                        value: value ?? null,
                        __typename: 'OnboardingState'
                    },
                    __callerPackage__: "onboarding-helpers"
                });
            });
        },
        onError: (error)=>{
            if ((0, $cbOce.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "onboarding-helpers"
    });
    const setOnboardingState = (0, $cozmU.useCallback)((newOnboardingState)=>{
        let states;
        if (Array.isArray(newOnboardingState)) // supports batch updates
        states = newOnboardingState;
        else // backwards compability for single key-value pair
        states = [
            newOnboardingState
        ];
        setState({
            variables: {
                states: states
            },
            optimisticResponse: {
                setOnboardingState: states.map(({ key: key, value: value })=>({
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }))
            }
        });
    }, [
        setState
    ]);
    return {
        setOnboardingState: setOnboardingState,
        error: error,
        called: called
    };
};
// safeguards against empty arrays or strings
const $6fc4b7bb962289cc$var$hasValidKeysToFetch = (key)=>{
    if (Array.isArray(key)) return key.length > 0;
    if (typeof key === 'string') return key.length > 0;
    return false;
};
const $6fc4b7bb962289cc$export$d5e7611ac338ec84 = (key, skip = false)=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const isAllowed = isLicensed || isGuest;
    const hasKeysToFetch = $6fc4b7bb962289cc$var$hasValidKeysToFetch(key);
    const skipQuery = skip || !isAllowed || !hasKeysToFetch;
    const { data: data, error: error, loading: loading, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: key
        },
        skip: skipQuery,
        __callerPackage__: "onboarding-helpers"
    });
    return {
        data: data,
        error: error,
        loading: loading,
        refetch: refetch
    };
};
module.exports["deserializeState"] = $6fc4b7bb962289cc$export$7ca8667598519375;
module.exports["useSetOnboardingState"] = $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf;
module.exports["useGetOnboardingState"] = $6fc4b7bb962289cc$export$d5e7611ac338ec84;

});

parcelRegister("209pV", function(module, exports) {
/**
 * @generated SignedSource<<a83598c413cebc1d8cb2388f4b0ca41c>>
 * @relayHash 3faa5f50f8c511a1bae008881ee58062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed
const $4f605ad876f6c5d9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "states"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "states",
                    "variableName": "states"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "setOnboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3faa5f50f8c511a1bae008881ee58062",
            "id": "1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed",
            "metadata": {},
            "name": "onboardingStateSetOnboardingStateMutation",
            "operationKind": "mutation",
            "text": "mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key,value}}"
        }
    };
}();
$4f605ad876f6c5d9$var$node.hash = "90b0af82da00eefb44f28228419e7c9e";
var $4f605ad876f6c5d9$export$2e2bcd8739ae039 = $4f605ad876f6c5d9$var$node;
module.exports["default"] = $4f605ad876f6c5d9$export$2e2bcd8739ae039;

});

parcelRegister("e6fvz", function(module, exports) {
/**
 * @generated SignedSource<<0c17cade527e0c98b3a6d07d61bdb0ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6eba286460e57a30$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "onboardingState_state",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ],
    "type": "OnboardingState"
};
$6eba286460e57a30$var$node.hash = "4458ec6e78736741d79615a29b68de83";
var $6eba286460e57a30$export$2e2bcd8739ae039 = $6eba286460e57a30$var$node;
module.exports["default"] = $6eba286460e57a30$export$2e2bcd8739ae039;

});

parcelRegister("cbOce", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $6fil2 = parcelRequire("6fil2");


var $1uFM6 = parcelRequire("1uFM6");

function $2f49c1e50cca9335$export$8715824c16ceeca0(error) {
    const isUnauthorized = error?.graphQLErrors?.[0]?.message === 'unauthorized' || (0, $1uFM6.isUnauthorizedError)(error);
    return isUnauthorized || (0, $6fil2.containsNetworkError)(error);
}
module.exports["isExpectedError"] = $2f49c1e50cca9335$export$8715824c16ceeca0;

});

parcelRegister("kvJHJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $gXfti = parcelRequire("gXfti");


var $knAY5 = parcelRequire("knAY5");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $8W4Gr = parcelRequire("8W4Gr");


var $2O7Qv = parcelRequire("2O7Qv");


var $18R9N = parcelRequire("18R9N");

const $d2938061b4a1e388$var$noop = ()=>{};
const $d2938061b4a1e388$var$EMBEDDED_PREFIX = 'embedded-';
const $d2938061b4a1e388$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { customData: customData = {}, onComplete: onComplete = $d2938061b4a1e388$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of Props guarantees that exactly one of `metricKey` or `metric`
    // is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$d2938061b4a1e388$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    // Capture before onComplete or a deferred paint callback can start another interaction.
    const binding = props.metric ? (0, $8W4Gr.getPageSegmentUFOBinding)(props.metric) : undefined;
    const stopTimeRef = (0, $cozmU.useRef)(stopTime);
    const customDataRef = (0, $cozmU.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $cozmU.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $cozmU.useCallback)(()=>{
        onComplete();
        let finalCustomData;
        if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
        else finalCustomData = customDataRef.current;
        const data = {
            ...finalCustomData,
            viewTransitionSource: (0, $lXYVJ.getViewTransitionSource)(),
            ...typeof stopTimeRef.current === 'number' ? {
                stopTime: stopTimeRef.current
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        };
        // An imperative start has no embedded context; retain its captured key and owner.
        if (binding && (binding.key === prefixedKey || binding.key === resolvedKey)) // Preserve React end-mark timing; stopTime is metadata on this API.
        (0, $8W4Gr.reportPageSegmentEndToUFO)(binding, {
            customData: data
        });
        else {
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${prefixedKey}`);
            (0, $2O7Qv.addCustomTimingForMetric)(prefixedKey);
            (0, $gXfti.addUFOCustomData)(data);
        }
    }, [
        binding,
        onComplete,
        prefixedKey,
        resolvedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
const $d2938061b4a1e388$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($d2938061b4a1e388$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $d2938061b4a1e388$export$a267cdf45880b07b;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});


//# sourceMappingURL=RestrictedSpace.1b0161ec.js.map
